// extracted by mini-css-extract-plugin
export default {"label":"CustomPagination_label__-2zd5","input":"CustomPagination_input__Fid12"};